import { RootState } from 'store';

export const availableRangesSelector = (state: RootState) =>
  state.map_v2.tabs.operational.availableRanges;

export const rangeSelector = (state: RootState) =>
  state.map_v2.tabs.operational.dateRange;

export const objectsSelector = (state: RootState) =>
  state.map_v2.tabs.operational.objects;
